<section class="register-init">
  <div class="register-init__card">
    <h1 class="register-init__heading">Create an account</h1>
    <p class="register-init__subhead">Track your results, manage bookings, and view your testing history.</p>
    @if (errorMessage()) {
      <bodyanalytics-alert variant="error">{{ errorMessage() }}</bodyanalytics-alert>
    }
    <bodyanalytics-register-account-form (submitFormEvent)="update($event)"></bodyanalytics-register-account-form>
  </div>
</section>
